<template>
  <div class="wrapper check-report-page">
    <div class="check-report-shell">
      <section class="check-report-hero">
        <div class="check-report-hero__inner">
          <p class="check-report-hero__eyebrow">{{ currentDate() }}</p>
          <h2 class="check-report-hero__title">iKids Check Report</h2>
          <p class="check-report-hero__subtitle">Attendance export and activity log for iKids check flow.</p>
        </div>
      </section>

      <section class="check-report-body">
        <div class="report-panel">
          <h3 class="report-panel__title">iKids Report Attendance</h3>
          <div class="report-form">
            <label class="report-field">
              <span class="report-field__label">Start Date</span>
              <CInput v-model="report_start_date" type="date" />
            </label>

            <label class="report-field">
              <span class="report-field__label">End Date</span>
              <CInput v-model="report_end_date" type="date" />
            </label>

            <label class="report-field">
              <span class="report-field__label">Class</span>
              <select v-model="report_class_id" class="report-field__select">
                <option value="0">Show All</option>
                <option v-for="item in listclass" :key="item.id" :value="item.id">{{ item.name }}</option>
              </select>
            </label>

            <label class="report-field">
              <span class="report-field__label">Grade</span>
              <select v-model="report_grade_id" class="report-field__select">
                <option value="0">Show All</option>
                <option v-for="item in listgrade" :key="item.id" :value="item.id">{{ item.name }}</option>
              </select>
            </label>

            <label class="report-field">
              <span class="report-field__label">Service</span>
              <select v-model="report_service_type" class="report-field__select">
                <option value="0">Show All</option>
                <option value="1">Service 1</option>
                <option value="2">Service 2</option>
              </select>
            </label>
          </div>

          <div class="report-panel__actions">
            <button type="button" class="report-action" @click="showIkidMonthlyReportAttendance">
              Monthly Report
            </button>
          </div>
        </div>

        <div class="report-panel">
          <div class="report-panel__header">
            <h3 class="report-panel__title">iKids Activity Log</h3>
            <div class="report-log-controls">
              <label class="report-log-controls__label">
                <span>Showing</span>
                <select v-model="metaLog.per_page" class="report-log-controls__select" @change="loadPerPageLog">
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
                <span>Entries</span>
              </label>
            </div>
          </div>

          <CDataTable
            sorter
            striped
            hover
            bordered
            :items="itemsLog"
            :fields="fieldsLog"
            :sort-by.sync="sortByLog"
            :sort-desc.sync="sortByDescLog"
            show-empty
            class="report-log-table"
          >
            <template #name="{ item }">
              <td v-if="item.name">
                <router-link :to="{ name: 'Detail Kids', query: { id: item.uuid } }" class="report-log-table__link">
                  {{ item.name }}
                </router-link>
              </td>
              <td v-else></td>
            </template>
          </CDataTable>

          <div class="report-log-footer">
            <p class="report-log-footer__meta">
              Showing {{ metaLog.from }} to {{ metaLog.to }} of {{ metaLog.total }} items
            </p>

            <b-pagination
              v-model="metaLog.current_page"
              :total-rows="metaLog.total"
              :per-page="Number(metaLog.per_page)"
              align="right"
              @change="handlePaginationLog"
            />
          </div>
        </div>
      </section>
    </div>

    <alertmodal />
  </div>
</template>

<script>
import EventBus from '@/eventBus'
import alertmodal from '@/views/alert/modal.vue'
import ikid from '@/services/ikid'

export default {
  name: 'IkidsCheckReport',
  components: {
    alertmodal,
  },
  data() {
    return {
      listclass: [],
      listgrade: [],
      itemsLog: [],
      fieldsLog: [
        { key: 'name', sortable: false },
        { key: 'action', sortable: false },
        { key: 'log_time', sortable: false },
      ],
      metaLog: {
        total: 0,
        current_page: 1,
        per_page: 10,
        from: 0,
        to: 0,
        is_active: 1,
      },
      sortByLog: 'log_time',
      sortByDescLog: true,
      is_active: 1,
      report_class_id: 0,
      report_grade_id: 0,
      report_start_date: '',
      report_end_date: '',
      report_service_type: 0,
    }
  },
  mounted() {
    this.loadClass()
    this.loadGrade()
    this.loadActivityLog()
  },
  methods: {
    currentDate() {
      const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
      const current = new Date()
      return current.getDate() + ' ' + months[current.getMonth()] + ' ' + current.getFullYear()
    },
    async loadClass() {
      try {
        const res = await ikid.getAllClass(this.$route.query.Pud)
        this.listclass = res.data || []
      } catch (err) {
        this.showError(err, 'Failed to load class list')
      }
    },
    async loadGrade() {
      try {
        const res = await ikid.getIkidGradeAll()
        this.listgrade = res.data || []
      } catch (err) {
        this.showError(err, 'Failed to load grade list')
      }
    },
    loadActivityLog() {
      const params = {
        page: this.metaLog.current_page,
        per_page: this.metaLog.per_page,
        sortby: this.sortByLog,
        sortbydesc: this.sortByDescLog ? 'DESC' : 'ASC',
        is_active: this.is_active,
      }

      ikid.getIkidActivity(params).then((res) => {
        const getData = res.data || {}
        this.itemsLog = getData.data || []
        this.metaLog = {
          total: getData.total || 0,
          current_page: getData.current_page || 1,
          per_page: getData.per_page || this.metaLog.per_page,
          from: getData.from || 0,
          to: getData.to || 0,
          is_active: res.is_active,
        }
      }).catch((err) => {
        this.showError(err, 'Failed to load activity log')
      })
    },
    loadPerPageLog() {
      this.metaLog.current_page = 1
      this.loadActivityLog()
    },
    handlePaginationLog(val) {
      this.metaLog.current_page = val
      this.loadActivityLog()
    },
    showIkidMonthlyReportAttendance() {
      const query = {}

      if (this.report_start_date !== '' && this.report_end_date !== '') {
        query.report_start_date = this.report_start_date
        query.report_end_date = this.report_end_date
      } else {
        this.showError(null, 'Please select start date and end date')
        return false
      }

      query.report_class_id = this.report_class_id
      query.report_grade_id = this.report_grade_id
      query.report_service_type = this.report_service_type

      const route = this.$router.resolve({
        path: '/reportview/ikid_attendance',
        query,
      })
      window.open(route.href, '_blank', 'height=800,width=1000')
    },
    showError(err, fallbackMessage) {
      const message = err && err.response && err.response.data && err.response.data.message
        ? err.response.data.message
        : fallbackMessage
      EventBus.$emit('OPEN_MODAL_ALERT', {
        title: 'Error',
        mode: 'danger',
        data: message,
      })
    },
  },
  watch: {
    sortByLog() {
      this.loadActivityLog()
    },
    sortByDescLog() {
      this.loadActivityLog()
    },
  },
}
</script>

<style scoped>
.check-report-page {
  min-height: 100%;
  padding: 0 !important;
  background:
    radial-gradient(circle at top, rgba(47, 109, 201, 0.12), transparent 35%),
    linear-gradient(180deg, #f7fbff 0%, #eef4fb 100%);
}

.check-report-shell {
  min-height: 100%;
}

.check-report-hero {
  padding: 18px 18px 20px;
  background:
    linear-gradient(180deg, rgba(247, 251, 255, 0.98) 0%, rgba(238, 244, 251, 0.94) 100%);
  border-bottom: 1px solid rgba(199, 215, 236, 0.8);
}

.check-report-hero__inner,
.check-report-body {
  max-width: 1180px;
  margin: 0 auto;
}

.check-report-hero__eyebrow {
  margin: 0 0 4px;
  color: #68819d;
  font-size: 13px;
  font-weight: 600;
}

.check-report-hero__title {
  margin: 0;
  color: #16375d;
  font-size: 30px;
  font-weight: 700;
}

.check-report-hero__subtitle {
  margin: 8px 0 0;
  color: #68819d;
  font-size: 15px;
}

.check-report-body {
  padding: 22px 18px 28px;
  display: grid;
  gap: 20px;
}

.report-panel {
  padding: 22px;
  border: 1px solid #cfdae8;
  border-radius: 24px;
  background: #fff;
  box-shadow: 0 18px 36px rgba(18, 57, 99, 0.08);
}

.report-panel__header {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: center;
  margin-bottom: 14px;
}

.report-panel__title {
  margin: 0 0 14px;
  color: #16375d;
  font-size: 22px;
  font-weight: 700;
}

.report-panel__header .report-panel__title {
  margin-bottom: 0;
}

.report-form {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
}

.report-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.report-field__label {
  color: #6c8198;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
}

.report-field__select {
  min-height: 38px;
  padding: 0 12px;
  border: 1px solid #c7d7ec;
  border-radius: 8px;
  background: #fff;
  color: #17324d;
}

.report-panel__actions {
  margin-top: 18px;
}

.report-action {
  min-width: 164px;
  min-height: 46px;
  padding: 0 18px;
  border: none;
  border-radius: 999px;
  background: #1367b4;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}

.report-log-controls__label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #5e738b;
  font-size: 14px;
}

.report-log-controls__select {
  min-height: 36px;
  padding: 0 10px;
  border: 1px solid #c7d7ec;
  border-radius: 8px;
  background: #fff;
}

.report-log-table__link {
  color: #1367b4;
  font-weight: 700;
}

.report-log-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-top: 16px;
}

.report-log-footer__meta {
  margin: 0;
  color: #5e738b;
  font-size: 14px;
}

@media (max-width: 768px) {
  .check-report-hero {
    padding: 16px 12px 18px;
  }

  .check-report-hero__title {
    font-size: 26px;
  }

  .check-report-body {
    padding: 16px 12px 20px;
  }

  .report-panel {
    padding: 18px 16px;
  }

  .report-form {
    grid-template-columns: 1fr;
  }

  .report-panel__header,
  .report-log-footer {
    flex-direction: column;
    align-items: stretch;
  }
}
</style>
